<template>
    <v-container fluid class="">
        <div class="dashboard-page">
            <v-list>
                <v-list-item v-for="(item, i) in datos"
                             :key="i">
                    <v-list-item-title>{{item}}</v-list-item-title>
                </v-list-item>
            </v-list>
            <v-row>
                <v-col cols=12>
                    <v-card class="daily-line ma-1" flat>
                        <v-card-text class="justify-center px-4 pb-0">   
                            <table id="tblDocs" style="margin: auto; width: 100%;">
                                <tbody>
                                    <tr>
                                        <td>
                                            <p class="justify-center font-weight-bold" style="font-size: 1.5em"> Documentos</p>
                                        </td>
                                        <td style="padding-left: 25%;">
                                            <p class="font-weight-bold" style="width: 120px; font-size: 1.5em;">Recibidos</p>
                                        </td>
                                    </tr>
                                    <template>
                                        <tr v-for="(item,index) in docs" :key="index" style="border-bottom-width: unset;">
                                            <td style="font-size: 1.3em;">{{item.dodescrip}}</td>
                                            <td style="padding-left: 24%;">

                                                <v-btn-toggle v-model="docs[index].gdrecepfisc"
                                                    tile
                                                    color="blue darken-1 accent-3"
                                                    group
                                                >
                                                    <v-btn :value="true" @click="emitOpc()">
                                                        Si
                                                    </v-btn>

                                                </v-btn-toggle>
                                            </td>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </div>
    </v-container>
</template>


<script>
    import { mapState } from 'vuex';
    import ApexChart from 'vue-apexcharts';
    import seguimientoService from '@/services/Seguimiento/seguimiento.service.js';
    import MetodosGenerales from "@/utils/metodosgenerales.vue.js";

    export default {
        components: {
            ApexChart
        },
        props: ['docs'],
        data() {
            return {

                apexLoading: false,
                total: 0,
                vehiculos: [],
                documentos: [],
                conductores: [],
                asistencia: [],
                asuntosrelevantes: [],
                datos: [],
                resp: [],
                dialog3: false,
                noComplete: false,

            };
        },
        computed: {
            ...mapState(["domain", "theme"]),
            ...mapState("Operacion", ["key"]),

        },

        created() {  
        },

        methods: {    
            
            emitOpc(){
                this.$emit('update:docs', this.docs);
            },

            async obtenerCargaInicial() {
                let reporte = await MetodosGenerales.obtenerSessionReporte('reporte');
                var respuesta = await seguimientoService.ObtenerEstadoRecpDocsFisc(reporte.nrreporte , reporte.svindice);
                
                await respuesta.forEach(element => {
                    for (const [key, value] of Object.entries(element)) {
                        if(typeof value == "object"){ element[key] = null }  
                    }
                });  
                this.$emit('update:docs', respuesta);
                console.log("La Primera Respuesta: ",respuesta);
            },
        },

        mounted() {
            this.obtenerCargaInicial();
        }

    };
</script>
<!--<style src="./src/components/pages/main/Dashboard.scss" lang="scss" />-->
<style>

</style>